module.exports = __webpack_public_path__ + "img/a72ff.c9ad92ce.svg";